import { Component } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { TranslatePipe } from '@next/core-lib/i18n';

@Component({
    selector: 'app-blight-advice-overview-legend',
    styleUrl: '../overview.component.scss',
    template: `
        <div class="legend">
            <div class="legend-icon-container">
                <img class="legend-icon spray"
                     ngSrc="../../../../../../../assets/icons/sprays_or_irrigation.svg"
                     height="24" width="24" alt=""/>
            </div>
            <span class="legend-label">{{ 'blightV2.advice.overview.sort.spray' | translate }}</span>
        </div>
    `,
    imports: [NgOptimizedImage, TranslatePipe],
})
export class LegendComponent {}
